/**
 * Юзернейм бота для ссылок t.me (поделиться ботом, экран «не в Telegram», экран переезда).
 * Задаётся при сборке: VITE_BOT_USERNAME в .env.local для dev-бота, ARG в apps/miniapp/Dockerfile для прода.
 */
export const BOT_USERNAME: string =
  (import.meta.env.VITE_BOT_USERNAME as string | undefined) ?? 'KvitsAppBot';
